import React from 'react'

export const pluralize = (num, titles) => {
  const number = parseInt(num)
  const cases = [2, 0, 1, 1, 1, 2]
  return titles[
    (number % 100 > 4 && number % 100 < 20)
      ? 2
      : cases[(number % 10 < 5) ? number % 10 : 5]
  ]
}

export const pluralizeStr = (str, num) => {
  return str.replace(/{([^{}]+)}/g, (_, result) =>
    pluralize(num, result.split('|'))
  )
}

const Plural = ({value, label}) => <span>{value} {pluralizeStr(label, value)}</span>

export default Plural
